export default __webpack_public_path__ + "static/media/P308.3.efe64ef3.mp3";